module.exports = __webpack_public_path__ + "static/img/4.8a6b2e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/entrance/4.png
// module id = dafq
// module chunks = 1